export const getReinsuranceYear = (salesEffectiveDate?: Date | null | undefined): number => {
  // No explicit date: flip at the live rollover moment. New RY prices are published
  // July 1 at 16:00 UTC, so "now" only counts as the new RY from that instant.
  if (!salesEffectiveDate) {
    const now = new Date();
    const year = now.getUTCFullYear();
    return now.getTime() >= Date.UTC(year, 6, 1, 16, 0, 0) ? year + 1 : year;
  }

  // Explicit sales-effective date: compare by calendar date only, ignoring time-of-day.
  // Coverage-request dates are date-only (UTC midnight), so July 1 must resolve to the
  // new RY even though midnight precedes the 16:00 UTC publish cutoff.
  const year = salesEffectiveDate.getUTCFullYear();
  return salesEffectiveDate.getUTCMonth() >= 6 ? year + 1 : year;
};

export const getReinsuranceYearAsDate = (salesEffectiveDate?: Date | null | undefined): Date => {
  const reinsuranceYear = getReinsuranceYear(salesEffectiveDate);
  return new Date(reinsuranceYear, 0, 1);
};
